import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./search-location.scss";

import Loader from "../../components/loader/loader";
// import CityCard from "../../components/city-card/city-card";
import CityLocationCard from "../../components/city-location-card/city-location-card";
import ExitButton from "../../assets/exit.png";
import BackButton from "../../assets/backward.png";

import GetCityAndLocationAPI from "../../services/GetCityAndLocation/GetCityAndLocation";
import { pageUrl } from "../../utils/pageConstant";
import ModalPopUp from "../../components/modal/modal";
import { TwoBtnModal } from "../../components/modal/modal";

const SearchLocation = () => {
  const navigate = useNavigate();
  const [toPage, setToPage] = useState('/explore');
  const [popularCities, setPopularCities] = useState([]);
  const [isLoader, setIsLoader] = useState(true);
  const [expandedCityIndex, setExpandedCityIndex] = useState(null);
  const existingLocality = sessionStorage.getItem("localityValue");
  const parsedLocality = existingLocality? JSON.parse(existingLocality) : [];
  const [selectedLocalities, setSelectedLocalities] = useState(parsedLocality);
  // const [selectedCity, setSelectedCity] = useState({});
  // const [selectedLocalities, setSelectedLocalities] = useState({});
  const [isModalOneOpen, setIsModalOneOpen] = useState(false)
  const [isModalTwoOpen, setIsModalTwoOpen] = useState(false)

  useEffect(() => {
    getLocationCity();
    const previousPage = sessionStorage.getItem("fromPage") || '';
    if(previousPage){
      if(previousPage === 'explore'){
        setToPage('/explore')
      }else{
        setToPage('/outlet-list')
      }
    }else{
      setToPage('/explore')
    }
  }, []);

  const getLocationCity = async () => {
    try {
      const responseData = await GetCityAndLocationAPI();
      setPopularCities(responseData);
      setIsLoader(false);
    } catch (error) {
      console.log("tokenValidate---", error);
    }
  };

  // const handleApply = () => {
  //   // Check if the selectedLocalities object is empty
  //   if (Object.keys(selectedLocalities).length === 0) {
  //     setIsModalOneOpen(true);
  //     return;
  //   }

  //   sessionStorage.setItem("localityValue",JSON.stringify(selectedLocalities));
    
  //   const cityNames = selectedLocalities.map(item => item.city);
  //   const uniqueCityNames = [...new Set(cityNames)]; // Remove duplicates
  //   sessionStorage.setItem("city", uniqueCityNames.join(","));

  //   //navigate("/explore");
  //   navigate(toPage);
  // };

  const handleApply = () => {
    // Check if the selectedLocalities object is empty
    if (selectedLocalities.length === 0) {
      setIsModalOneOpen(true);
      return;
    }
  
    // Ensure each selected city has a 'name' key with a value (either 'All' or specific localities)
    const isAnyCityWithoutLocality = selectedLocalities.some(item => !item.name || item.name.trim() === "");
    
    if (isAnyCityWithoutLocality) {
      setIsModalOneOpen(true);
      return;
    }
  
    // Save selected localities and city names to session storage
    sessionStorage.setItem("localityValue", JSON.stringify(selectedLocalities));
    
    const cityNames = selectedLocalities.map(item => item.city);
    const uniqueCityNames = [...new Set(cityNames)]; // Remove duplicates
    sessionStorage.setItem("city", uniqueCityNames.join(","));
  
    // Navigate to the next page
    navigate(toPage);
  };
  

  const handleOk = () => {
    setIsModalOneOpen(false)
  }

  const handleReset = () => {
    if (selectedLocalities.length !== 0) {
      setSelectedLocalities([]);
    } else {
      setIsModalTwoOpen(true);
    }
  };

  const handleModalYes = () => {
    sessionStorage.setItem("city","")
    sessionStorage.setItem("locality","")
    sessionStorage.setItem("localityValue","")
    //navigate('/explore')
    navigate(-1);
  }

  const handleModalNo = () => {
    setIsModalTwoOpen(false)
    return
  }

  const onHandleBackBtn = () => {
    // navigate("/outlet-list");
    navigate(toPage);
  };

  const onHandleCloseBtn = () => {
    //navigate("/outlet-list");
    navigate(toPage);
  };

  return (
    <>
    <div className="search-page">
      {isLoader && <Loader />}
      <div className="cityPageControls">
        <img style={{height: "30px"}} src={BackButton} alt="x" onClick={onHandleBackBtn}/>
        <img style={{height: "30px"}} src={ExitButton} alt="x" onClick={onHandleCloseBtn}/>
      </div>
      <div className="search-header">Select Location</div>
      {/* <div className="search-sub-header">
        Choose a city here which can be changed later on
      </div> */}
      {/* <SearchBar searchLabel="Type city here" handleNaviagte={handleNavigate} /> */}
      <div className="pop-city-text">We are present in these cities,</div>
      <div className="popular-city-section">
        {popularCities &&
         <CityLocationCard 
            expandedCityIndex={expandedCityIndex}
            setExpandedCityIndex={setExpandedCityIndex}
            locationData={popularCities} 
            // setSelectedCity={setSelectedCity} 
            // selectedCity={selectedCity}
            setSelectedLocalities={setSelectedLocalities}
            selectedLocalities={selectedLocalities}
         />
        }
      </div>
    </div>
    <div className="bottomFilterSection">
      <button className="filterButtons" onClick={handleReset}>RESET</button>
      <button className="filterButtons" onClick={handleApply}>APPLY</button>
    </div>
    <ModalPopUp
      isOpen={isModalOneOpen}
      handleModalClose={handleOk}
      message={{ title: "", text: "Please select any locality!!" }}
      icon=""
    />
    <TwoBtnModal
      isOpen={isModalTwoOpen}
      handleOk={handleModalYes}
      handleCancel={handleModalNo}
      message={{ title: "", text: "Do you want to view all the outlets?" }}
      icon=""
      className=""
      showCancelButton={true} 
    />
    </>
  );
};

export default SearchLocation;
